"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _renderProps = require("../../../libs/renderProps");

var _SearchableFilterSelector = _interopRequireDefault(require("./SearchableFilterSelector"));

var _categories = require("@insided/shared/utils/categories");

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _utils = require("@insided/control/modules/Categories/shared/utils");

var _NestedDropdownHeader = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown/NestedDropdownHeader"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _excluded = ["items"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getMergedCategoryList = function getMergedCategoryList(groupedCategories) {
  var mergedCategoryList = [];
  Object.entries(groupedCategories).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        categoryList = _ref2[1];

    mergedCategoryList.push.apply(mergedCategoryList, (0, _toConsumableArray2.default)(categoryList));
  });
  return mergedCategoryList;
};

var getMatchingCategoryTitles = function getMatchingCategoryTitles(flatCategoryList, selectedCategoryIds) {
  var matchingCategories = flatCategoryList.filter(function (category) {
    return selectedCategoryIds.includes(String(category.id));
  });
  return matchingCategories.map(function (category) {
    return category.name;
  });
};

var getContentCategoryIds = function getContentCategoryIds(flatCategoryList) {
  var contentCategories = flatCategoryList.filter(function (_ref3) {
    var isContainer = _ref3.isContainer;
    return !isContainer;
  });
  return contentCategories.map(function (_ref4) {
    var id = _ref4.id;
    return String(id);
  });
};

var addCategoryIdsToList = function addCategoryIdsToList(categoryIdList, category, childrenIds) {
  if (category.isContainer) {
    categoryIdList.push.apply(categoryIdList, (0, _toConsumableArray2.default)(childrenIds));
  } else {
    categoryIdList.push(String(category.id));
  }

  return categoryIdList;
};

var removeCategoryIdsFromList = function removeCategoryIdsFromList(categoryIdList, category, childrenIds) {
  if (category.isContainer) {
    return categoryIdList.filter(function (id) {
      return !childrenIds.includes(id);
    });
  }

  return categoryIdList.filter(function (id) {
    return id !== String(category.id);
  });
};

function getDefaultExpandedDropdowns(items) {
  var expandedDropdowns = {};
  Object.keys(items).forEach(function (moduleType) {
    expandedDropdowns[moduleType] = true;
  });
  return expandedDropdowns;
}

var CategoryFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryFilterSelector, _Component);

  var _super = _createSuper(CategoryFilterSelector);

  function CategoryFilterSelector() {
    var _this$props$items, _this$props$selectedF;

    var _this;

    (0, _classCallCheck2.default)(this, CategoryFilterSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "flatCategoriesList", (0, _utils.flattenCategoryList)(getMergedCategoryList(_this.props.items)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      items: (_this$props$items = _this.props.items) !== null && _this$props$items !== void 0 ? _this$props$items : {},
      isSelectAll: false,
      selectedCategoryIds: (_this$props$selectedF = _this.props.selectedFilterItems) !== null && _this$props$selectedF !== void 0 ? _this$props$selectedF : [],
      expandedDropdowns: getDefaultExpandedDropdowns(_this.props.items)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdown", function (module) {
      _this.setState(function (prevState) {
        var _prevState$expandedDr;

        return {
          expandedDropdowns: _objectSpread(_objectSpread({}, prevState.expandedDropdowns), {}, (0, _defineProperty2.default)({}, module, !((_prevState$expandedDr = prevState.expandedDropdowns[module]) !== null && _prevState$expandedDr !== void 0 ? _prevState$expandedDr : false)))
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onToggleCollapse", function (categoryId) {
      _this.setState(function (_ref5) {
        var items = _ref5.items;
        return {
          items: (0, _categories.collapseCategory)(items, categoryId)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectAll", function () {
      var isSelectAll = _this.state.isSelectAll;
      var selectedCategoryIds = [];

      if (!isSelectAll) {
        selectedCategoryIds = getContentCategoryIds(_this.flatCategoriesList);
      }

      _this.setState(function (_ref6) {
        var isSelectAll = _ref6.isSelectAll;
        return {
          isSelectAll: !isSelectAll,
          selectedCategoryIds: selectedCategoryIds
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelect", function (categoryId, checked) {
      var items = _this.props.items;
      var selectedCategoryIds = _this.state.selectedCategoryIds;
      var category = (0, _categories.findCategoryById)(getMergedCategoryList(items), categoryId);
      var selectedCategoryIdsCopy = JSON.parse(JSON.stringify(selectedCategoryIds));

      if (!category) {
        return;
      }

      var childrenIds = [];

      if (category.isContainer) {
        childrenIds = getContentCategoryIds((0, _utils.flattenCategoryList)(category.children));
      }

      if (checked) {
        selectedCategoryIdsCopy = addCategoryIdsToList(selectedCategoryIdsCopy, category, childrenIds);
      } else {
        selectedCategoryIdsCopy = removeCategoryIdsFromList(selectedCategoryIdsCopy, category, childrenIds);
      }

      _this.setState(function (_ref7) {
        var isSelectAll = _ref7.isSelectAll;
        return {
          selectedCategoryIds: selectedCategoryIdsCopy,
          isSelectAll: selectedCategoryIdsCopy.length === 0 ? false : isSelectAll
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategoryFilterSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          disableApplyButton = _this$props.disableApplyButton;
      var _this$state = this.state,
          items = _this$state.items,
          selectedCategoryIds = _this$state.selectedCategoryIds,
          isSelectAll = _this$state.isSelectAll,
          expandedDropdowns = _this$state.expandedDropdowns;
      var selectionLabel = isSelectAll ? 'Deselect all' : 'Select all';
      return (0, _preact.h)("div", null, (0, _preact.h)(_SearchableFilterSelector.default, {
        items: this.flatCategoriesList,
        onClickSelectAll: this.onSelectAll,
        selectionLabel: selectionLabel,
        placeholder: "Search for category or group"
      }, function (_ref8) {
        var value = _ref8.value;
        return (0, _preact.h)("div", null, Object.entries(items).map(function (_ref9) {
          var _expandedDropdowns$mo;

          var _ref10 = (0, _slicedToArray2.default)(_ref9, 2),
              module = _ref10[0],
              categories = _ref10[1];

          var categoryName = (0, _categories.getModuleNameFromType)(parseInt(module));
          var filteredCategories = JSON.parse(JSON.stringify(categories));

          if (value) {
            filteredCategories = (0, _categories.filterCategoriesByTitle)(filteredCategories, value);
          }

          if (filteredCategories.length === 0) {
            return null;
          }

          var isExpanded = (_expandedDropdowns$mo = expandedDropdowns[module]) !== null && _expandedDropdowns$mo !== void 0 ? _expandedDropdowns$mo : true;
          return (0, _preact.h)("div", {
            key: categoryName
          }, (0, _preact.h)(_NestedDropdownHeader.default, null, (0, _preact.h)("div", {
            role: "button",
            tabIndex: 0,
            "aria-expanded": isExpanded,
            "aria-controls": "dropdown-panel-".concat(module),
            onClick: function onClick() {
              return _this2.toggleDropdown(module);
            },
            onKeyDown: function onKeyDown(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();

                _this2.toggleDropdown(module);
              }
            },
            className: "dropdown-selector__header-wrapper"
          }, (0, _preact.h)("span", null, categoryName), (0, _preact.h)("span", {
            "aria-hidden": "true"
          }, (0, _preact.h)(_assets.default, {
            icon: isExpanded ? 'chevronUp' : 'chevronDown'
          })))), isExpanded && (0, _preact.h)(_NestedDropdown.default, {
            labelId: "category-filter",
            items: filteredCategories,
            onMultiSelect: _this2.onSelect,
            selectedItems: selectedCategoryIds,
            depth: 1,
            onToggleCollapse: _this2.onToggleCollapse
          }));
        }));
      }), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: selectedCategoryIds,
        isApplyButtonDisabled: disableApplyButton !== null && disableApplyButton !== void 0 ? disableApplyButton : selectedCategoryIds.length === 0
      }));
    }
  }]);
  return CategoryFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(CategoryFilterSelector, "create", function (config) {
  var items = config.items,
      rest = (0, _objectWithoutProperties2.default)(config, _excluded);
  return _objectSpread({
    component: CategoryFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(selectedCategoryIds) {
      var flatCategoryList = (0, _utils.flattenCategoryList)(getMergedCategoryList(items));
      var matchingItems = getMatchingCategoryTitles(flatCategoryList, selectedCategoryIds);
      var firstItem = matchingItems[0];
      var otherItems = matchingItems.length > 1 ? "+".concat(matchingItems.length - 1) : '';
      return "".concat(firstItem, " ").concat(otherItems);
    },
    items: items
  }, rest);
});
var _default = CategoryFilterSelector;
exports.default = _default;